import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';

//This page functions as a home page and displays all the design folders

const Home = () => {
  
  const [user, setUser] = useContext(UserContext);
  const navigate = useNavigate();

  CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

  const [designs, setDesigns] = useState([]);
  let response24 = useInvoke("WebApps", "24", {});
  const [columns, setColumns] = useState([]);
  const [myDesignRows, setMyDesignRows] = useState([]);
  const [allDesignRows, setAllDesignRows] = useState([]);

  //redirect the user to change password screen if flag is detected
  useEffect(() => {
    if(user["email"] != undefined) {
      if(user["mustchangepassword"] == true || user["mustchangepassword"] == "true") {
          navigate("/ChangePassword");
      }
    }
      
  }, [user]);

 useEffect(() => {
    if (response24.data.payload != undefined) {
      let myData = JSON.parse(response24.data.payload).data;
      let myRowsList = [];
      let allRowsList = [];
      const normalizedUserName = `${user["firstname"] || ""} ${user["lastname"] || ""}`.trim().toLowerCase();

      myData.forEach((entry, index) => { entry["key"] = index;
      //Append and pad out the ID with 'DP' and 0's 
        let num = entry[0].toString(); while (num.length < 6) num = "0" + num; 
        
        let row = [
          {type: "link", content: {text: `DP${num}`, link: `/designFolder/details/${entry[9]}`}}, 
          {type: "text", content: {text: entry[1]}}, 
          {type: "text", content: {text: entry[2]}}, 
          {type: "text", content: {text: entry[3]}}, 
          {type: "text", content: {text: entry[4]}}, 
          {type: "text", content: {text: entry[5]}}, 
          {type: "text", content: {text: entry[6]}}, 
          {type: "text", content: {text: entry[7]}},
          {type: "text", content: {text: entry[8]}}
        ];
        const normalizedDesignEngineer = String(entry[5] || "").replace(/[^a-z0-9]+/gi, " ").trim().toLowerCase();
        const belongsToCurrentUser = normalizedUserName && normalizedDesignEngineer.includes(normalizedUserName);

        allRowsList.push(row);

        if (belongsToCurrentUser) {
          myRowsList.push(row);
        }
      });

      setDesigns(myData);

      setColumns(["ID", "Ref #", "Cust Job ID", "Customer", "Location", "Design Engineer", "Industry", "Materials Hdld", "Creation Date"]);
      setMyDesignRows(myRowsList);
      setAllDesignRows(allRowsList);
  }
 }, [response24.data.payload, user]);

 document.title = "Design Project Library";
 return (
  <div className="designFolder" style={{marginRight: "24px", marginLeft: "24px", maxWidth: "1280px", margin: "auto"}}>
  {user["email"] != undefined && (
    <>
      <h2>Design Projects</h2>

      <div className="row">
        <div className="col-sm-6">
          <div className="dataTables_length" id="designFolders_length">
            <Link className="btn btn-primary" to="/DesignFolder/New">New Design Project</Link>
          </div>
        </div>
      </div>

      <ul className="nav nav-tabs" id="designProjectTabs" role="tablist" style={{ marginTop: "20px" }}>
        <li className="nav-item" role="presentation">
          <button className="nav-link active" id="my-designs-tab" data-bs-toggle="tab" data-bs-target="#my-designs" type="button" role="tab" aria-controls="my-designs" aria-selected="true">
            My Designs ({myDesignRows.length})
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button className="nav-link" id="all-designs-tab" data-bs-toggle="tab" data-bs-target="#all-designs" type="button" role="tab" aria-controls="all-designs" aria-selected="false">
            All Designs ({allDesignRows.length})
          </button>
        </li>
      </ul>
      <div className="tab-content" id="designProjectTabContent" style={{ paddingTop: "16px" }}>
        <div className="tab-pane fade show active" id="my-designs" role="tabpanel" aria-labelledby="my-designs-tab">
          {myDesignRows.length > 0 ? (
            <DynamicGrid columnNames={columns} tableData={myDesignRows} sortable={true} defaultsortindex={8} descending={true}/>
          ) : (
            <p className="text-muted">No designs are assigned to you.</p>
          )}
        </div>
        <div className="tab-pane fade" id="all-designs" role="tabpanel" aria-labelledby="all-designs-tab">
          {allDesignRows.length > 0 ? (
            <DynamicGrid columnNames={columns} tableData={allDesignRows} sortable={true} defaultsortindex={8} descending={true}/>
          ) : (
            <p className="text-muted">There are no designs to display.</p>
          )}
        </div>
      </div>
    </>
  )}
</div>
 );
};

export default Home;
